export default "__VITE_ASSET__M4Qf7LlX__"